@if (showLoader) {
  <div class="global-action-block">
    <!-- Blocks the user from doing any action while any HTTP load is in progress -->
  </div>
}

@if (showLoader) {
  <div class="global-loader">
    <i class="fas fa-sync fa-spin"></i>
    <div class="d-inline-block ml-3">Loading</div>
  </div>
}
